// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--1JpCG";
export var small = "footer-module--small--2VNbq";